import React, { forwardRef, useState, useEffect } from 'react'
import { Cascader } from '@ow/comps'
import { css, Global } from '@emotion/react'

const Filter = function (
  { opts = {}, onChange, value, onFetchRemoteData, style = {} },
  ref
) {
  const { multiple } = opts
  const [standards, setStandards] = useState([])

  useEffect(() => {
    if (onFetchRemoteData) {
      const standard = onFetchRemoteData('standard')
      standard.fetchTreeData().then((data) => {
        setStandards(data)
      })
    }
  }, [])

  return (
    <div className="w-full" ref={ref}>
      <Global
        styles={css`
          .cas-dropdown {
            .rc-tree-select-tree-treenode {
              width: fit-content !important;
            }
          }
        `}
      />
      <Cascader
        tree={standards}
        inputStyle={{
          width: '100%',
          height: '34px',
          ...style,
          paddingLeft: multiple ? '0' : style.paddingLeft,
        }}
        fieldNames={{
          label: 'title',
          value: 'objectId',
          children: 'children',
        }}
        treeCheckable={multiple}
        dropdownClassName="cas-dropdown"
        placeholder={opts.hint || `请选择${opts.title}`}
        multiple={multiple}
        onChange={(selectedKeys) => {
          // if (multiple) {
          //   if (node && node[0] && node[0].children) {
          //     Toast.error({
          //       title: '只能选择末级指标',
          //     })
          //     return
          //   }
          // } else if (node && node.children) {
          //   Toast.error({
          //     title: '只能选择末级指标',
          //   })
          //   return
          // }s
          if (selectedKeys) {
            onChange(multiple ? selectedKeys : [selectedKeys])
          } else {
            onChange('')
          }
        }}
        value={value || []}
        notFoundContent="暂无数据"
      />
    </div>
  )
}

export default forwardRef(Filter)
